import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/leased-line1.png'
import _imports_1 from '../assets/leased-line2.png'
import _imports_2 from '../assets/leased-line3.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"35px","font-weight":"bold"} }, "Smart internet for Business", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Businesses need robust, seamless, and secure connectivity to communicate and transact over the internet. Having basic ILL is no longer an option, even for Small and Medium Businesses (SMBs). ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "The new smart internet offering from Jtel is a state-of-the-art solution which helps SMBs get robust connectivity, security, manageability, and clear visibility of its users and network. It is an internet leased line bundled with cloud-based security and a Do-It-Yourself (DIY) interface which is easy to access, install, use, and view. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Business owners will no longer have to deal with IT problems on their own and can rely on Jtel smart internet as the one-stop full-stack solution for all their connectivity and security needs. The solution offers: ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ul", { class: "ml-10 mt-2" }, [
  /*#__PURE__*/_createElementVNode("li", null, " DNS-based (Domain Name Service) security that guards against malicious content, online threats and gives the user the ability to block content categories as required "),
  /*#__PURE__*/_createElementVNode("li", null, " Fully managed services that are easy to install, use and maintain "),
  /*#__PURE__*/_createElementVNode("li", null, " Increased productivity with best-in-class uptime "),
  /*#__PURE__*/_createElementVNode("li", null, " Dedicated and secure access to the internet on a high-speed, steady, and reliable connection ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mt-15" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_jt_leased_line_features = _resolveComponent("jt-leased-line-features")!
  const _component_jt_need_guidance = _resolveComponent("jt-need-guidance")!
  const _component_jt_footer = _resolveComponent("jt-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "mt-3 mx-0 mx-md-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex justify-center cursor-pointer" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, { src: _imports_0 })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "mt-5 mx-2 mx-md-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "7"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "5",
          class: "d-none d-md-flex justify-center cursor-pointer image-holder"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, { src: _imports_1 })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "mt-3 mx-0 mx-md-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex justify-center cursor-pointer" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, { src: _imports_2 })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_jt_leased_line_features),
    _hoisted_6,
    _createVNode(_component_jt_need_guidance),
    _createVNode(_component_jt_footer)
  ], 64))
}